__turbopack_context__.v({
  "className": "inter_ae86fdc4-module__S2sK2W__className",
  "variable": "inter_ae86fdc4-module__S2sK2W__variable",
});
